import { formatNumber } from './format-number';

const SECOND = 1_000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;

export const formatAge = (ms: number, locale: string): string => {
  const elapsed = Math.max(ms, 0);
  if (elapsed < MINUTE) return `${formatNumber(Math.floor(elapsed / SECOND), locale)} s`;
  if (elapsed < HOUR) return `${formatNumber(Math.floor(elapsed / MINUTE), locale)} min`;
  return `${formatNumber(Math.floor(elapsed / HOUR), locale)} h`;
};
